document.addEventListener("DOMContentLoaded", function() {

  var firstTime = true;
  var btnCalendly = document.querySelectorAll('.button.button--primary[href="#calendly"]');
  for (var i = 0; i < btnCalendly.length; i++) {
    btnCalendly[i].removeAttribute("href");
    btnCalendly[i].setAttribute("calendly","");
    btnCalendly[i].addEventListener('click', function(event) {
      document.querySelector(".calendly-badge-content").click();
    });
  }


  
  const menuDetails = document.querySelectorAll('header-menu details');
  menuDetails.forEach(function(details) {
    details.addEventListener('mouseenter', function() {
      this.setAttribute('open', true);
    });
    
    details.addEventListener('mouseleave', function() {
      this.removeAttribute('open');
    });
    
    const summary = details.querySelector('summary');
    summary.addEventListener('click', function(event) {
      event.preventDefault();
    });
  });



  const accordionToggles = document.querySelectorAll('details summary');
  accordionToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      const details = this.closest('details');
      if (!details) return;
      
      const content = details.querySelector('.accordion__content, [id^="CollapsibleAccordion"]');
      if (!content) return;
      
      const isOpen = details.hasAttribute('open');
      
      if (!isOpen) {
        e.preventDefault();
        
        details.setAttribute('open', '');
        
        setTimeout(() => {
          const height = content.scrollHeight;
          content.style.height = '0px';
          content.classList.add('is-active');
          
          content.offsetHeight;
          
          content.style.height = height + 'px';
          
          setTimeout(() => {
            content.style.height = '';
          }, 300);
        }, 10);
      } else {
        e.preventDefault();
        
        const height = content.scrollHeight;
        content.style.height = height + 'px';
        
        content.offsetHeight;
        
        content.style.height = '0px';
        content.classList.remove('is-active');
        
        setTimeout(() => {
          details.removeAttribute('open');
          content.style.height = '';
        }, 300);
      }
    });
  });


  var summaryA = document.querySelectorAll('.header .header__inline-menu summary.header__menu-item a');
  for (var i = 0; i < summaryA.length; i++) {
    summaryA[i].addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = this.getAttribute('href');
    });
  }
  
  
});
